"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.SegmentNavigationTests = void 0;
var utils_1 = require("../../support/utils");
var viaArrowKeys_1 = require("./viaArrowKeys");
var viaJS_1 = require("./viaJS");
// Via Tab Key doesn't work
// Cypress Tab plugin doesn't support `event.preventDefault()` yet
// https://github.com/Bkucera/cypress-plugin-tab/issues/52
// import { viaTabKey } from './viaTabKey'
var SegmentNavigationTests = /** @class */ (function (_super) {
    __extends(SegmentNavigationTests, _super);
    // viaTabKey:() => void
    function SegmentNavigationTests(utils) {
        var _this = _super.call(this, utils) || this;
        _this.viaArrowKeys = function () { return (0, viaArrowKeys_1.viaArrowKeys)(utils); };
        _this.viaJS = function () { return (0, viaJS_1.viaJS)(utils); };
        return _this;
        // this.viaTabKey = () => viaTabKey(utils)
    }
    return SegmentNavigationTests;
}(utils_1.TestSuite));
exports.SegmentNavigationTests = SegmentNavigationTests;
